var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import Project from './Project';
var StyledProjectList = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  list-style: none;\n  padding: 0;\n  margin: 0 0 2rem;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  list-style: none;\n  padding: 0;\n  margin: 0 0 2rem;\n  justify-content: space-between;\n"])));
var ProjectList = function (_a) {
    var data = _a.data, scrollTop = _a.scrollTop;
    var projects = data
        .filter(function (item) { return item.hidden !== true; })
        .map(function (item, index) { return (React.createElement(Project, { key: index, data: item, scrollTop: scrollTop })); });
    return React.createElement(StyledProjectList, null, projects);
};
export default ProjectList;
var templateObject_1;
